import React from 'react';
import { motion } from 'framer-motion';
export function Offer() {
  const scrollToCompra = () => {
    const element = document.querySelector('#compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const bonos = [{
    title: 'Bono 1: Lista "Dietética Sin Vueltas"',
    desc: 'La guía de compra completa con los scripts exactos para pedir en el mostrador, las señales de calidad de cada ingrediente y los sustitutos para cuando no hay stock. Una sola visita bien hecha y salís con todo lo que necesitás para 2 a 3 meses de protocolo.',
    img: 'https://cdn.magicpatterns.com/uploads/51dw1wu1rRUPXFMAz9gWg6/BONO_1_adn-removebg-preview.png'
  }, {
    title: 'Bono 2: Pack "Etiquetas + Fechas" (Control de Vencimientos PRO)',
    desc: 'Las etiquetas imprimibles para todos los frascos y atomizadores, la tabla de vida útil para pegar en la heladera, el registro de lotes y la rutina de limpieza del atomizador de 1 minuto. El sistema que evita que uses un tónico vencido sin saberlo.',
    img: 'https://cdn.magicpatterns.com/uploads/xfearYWXJGJ6SWRfddwWby/BONO_2_adn-removebg-preview.png'
  }, {
    title: 'Bono 3: Tracker "Fotos + Caída" (Progreso en 90 Días)',
    desc: 'El protocolo fotográfico exacto para medir el progreso de forma objetiva, el tracker semanal de caída con escala de 1 a 5, las planillas de evaluación del Día 0, Día 30, Día 60 y Día 90, y el semáforo de avance con acciones específicas para cada resultado.',
    img: 'https://cdn.magicpatterns.com/uploads/ma1iizoAGzdAimEu3BKirQ/BONO_3_ADN-removebg-preview.png'
  }, {
    title: 'Bono 4: Guía "Alergias y Piel Sensible" (Protocolo Anti-Irritación)',
    desc: 'El mini test de sensibilidad cutánea, el Test de la Muñeca Extendido en 4 fases para pieles sensibles, la tabla completa de alérgenos con sustitutos seguros y el Plan de Arranque Suave de 14 días para pieles reactivas.',
    img: 'https://cdn.magicpatterns.com/uploads/geJPi4JbbJvmSobSEA9R2U/BONO_4_ADN-removebg-preview.png'
  }, {
    title: 'Bono 5: Scripts "Rutina Express" (5, 10 y 20 Minutos)',
    desc: 'Las 3 rutinas cerradas para cuando no tenés tiempo, la Rutina de Viaje sin ingredientes, la Regla del 1 Acto para los días más difíciles y los checklists imprimibles para pegar en el baño. Porque el mayor enemigo de los resultados es el abandono.',
    img: 'https://cdn.magicpatterns.com/uploads/snngLJEGyDiWXKS4SyMeU1/BONO_5_ADN-removebg-preview.png'
  }];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-96">
      <div className="max-w-4xl mx-auto" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-98">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-10 text-center" data-id="element-99">
            TODO LO QUE RECIBÍS CON EL SISTEMA MEGAKIT
          </h2>

          <div className="bg-gray-50 p-8 rounded-lg border border-gray-200 mb-12" data-id="element-100">
            <h3 className="text-2xl font-bold text-gold mb-6 flex items-center gap-3" data-id="element-101">
              <span data-id="element-102">📚</span> EL SISTEMA PRINCIPAL: 6 TOMOS COMPLETOS
            </h3>
            <ul className="space-y-4 text-gray-600" data-id="element-103">
              <li data-id="element-104">
                <strong className="text-gray-900" data-id="element-105">
                  Tomo 1: Fase de Desmonte
                </strong>{' '}
                — La limpieza profunda que prepara el terreno para todo lo
                demás. Protocolo de exfoliación, suavización de fibrosis y
                enjuague desmineralizante.
              </li>
              <li data-id="element-106">
                <strong className="text-gray-900" data-id="element-107">
                  Tomo 2: Laboratorio Botánico
                </strong>{' '}
                — Las 5 recetas de tónicos con el método de extracción correcto,
                las proporciones exactas y los modos de uso. El contenido
                central del sistema.
              </li>
              <li data-id="element-108">
                <strong className="text-gray-900" data-id="element-109">
                  Tomo 3: Blindaje Hormonal
                </strong>{' '}
                — El protocolo anti-DHT tópico con cafeína, fitosteroles de
                calabaza y lectinas de ortiga. Sin efectos secundarios
                sistémicos.
              </li>
              <li data-id="element-110">
                <strong className="text-gray-900" data-id="element-111">
                  Tomo 4: Turbina de Riego
                </strong>{' '}
                — Las técnicas de masaje e inversión para activar la circulación
                capilar. El protocolo de 20 minutos que transforma el cuero
                cabelludo.
              </li>
              <li data-id="element-112">
                <strong className="text-gray-900" data-id="element-113">
                  Tomo 5: Combustible Biológico
                </strong>{' '}
                — La guía nutricional completa con el Licuado de Carga Capilar y
                los suplementos naturales de dietética.
              </li>
              <li data-id="element-114">
                <strong className="text-gray-900" data-id="element-115">
                  Tomo 6: Operativo Facha
                </strong>{' '}
                — El mantenimiento, el manejo del cortisol, el camuflaje natural
                y el Calendario de Guerra Capilar semanal.
              </li>
            </ul>
          </div>

          <div className="mb-16" data-id="element-116">
            <div className="text-center mb-10" data-id="element-117">
              <h3 className="text-3xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-3" data-id="element-118">
                <span data-id="element-119">🎁</span> LOS 5 BONOS DE IMPLEMENTACIÓN
              </h3>
              <p className="text-xl text-gold font-bold bg-green-50 inline-block px-6 py-2 rounded-full border border-green-200" data-id="element-120">
                (INCLUIDOS SIN CARGO ADICIONAL POR EL DÍA DE HOY)
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-121">
              {bonos.map((bono, idx) => <motion.div key={idx} whileHover={{
              y: -5
            }} className="bg-gray-50 p-6 rounded-lg border border-gray-200 flex flex-col cursor-pointer group" onClick={scrollToCompra} data-id="element-122">
                  <div className="h-56 w-full mb-6 flex items-center justify-center relative" data-id="element-123">
                    <div className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded z-10" data-id="element-124">
                      GRATIS HOY
                    </div>
                    <img src={bono.img} alt={bono.title} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500 drop-shadow-lg" data-id="element-125" />
                  </div>
                  <h4 className="font-bold text-xl text-gray-900 mb-3" data-id="element-126">
                    {bono.title}
                  </h4>
                  <p className="text-gray-500 text-sm leading-relaxed" data-id="element-127">
                    {bono.desc}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}